$(document).ready(function () {
  // 제품 정보 주입
  const productData = {
    boosterProX2: {
      id: "boosterProX2",
      name: "Booster Pro X2",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/x2_pink.png?v=1784875011",
            width: "100px",
          },
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/x2_wt.png?v=1784875011",
            width: "100px",
          },
        ],
        colors: ["#FFCDCD", "#EFEFEF"],
        link: "/products/mini-booster-pro-plus",
      },
      specs: {
        Mode: ["Booster X2 Mode", "Derma Shot X2 Mode", "MC X2 Mode", "Airshot X2 Mode", "Mask Mode", "Dual Mode"],
        Weight: ["230g"],
        "How it works": ["Electroporation", "Medium-frequency (EMS)", "Microcurrent", "Electric-needle", "Booster Dual Tech", "AI Care"],
        Benefits: ["Absorbs active ingredients", "Adds facial volume", "Adds facial contour", "Takes care of pores", "Adds radiance & firmness", "Brightens skin with firmness", "Soothes skin"],
        "Accessory Compatibility": [],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
        "App Connectivity": [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/supported.png?v=1768200362",
        ],
      },
    },
    boosterPro: {
      id: "boosterPro",
      name: "Booster Pro",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_booster_bk.png?v=1768198626",
            width: "100px",
          },
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_booster_pk.png?v=1768198626",
            width: "100px",
          },
        ],
        colors: ["#000000", "#FFCDCD"],
        link: "/products/age-r-booster-pro",
      },
      specs: {
        Mode: ["Booster Mode", "Derma Shot Mode", "MC Mode", "Air Shot Mode"],
        Weight: ["154g"],
        "How it works": ["Electroporation", "EMS", "Microcurrent", "Electric-needle"],
        Benefits: [
          "Boosts overall skin radiance and glow",
          "Helps with volumizing the forehead, smile lines, and under-eye area",
          "Care for overall facial contours",
          "Minimizes enlarged pores",
          "Cares for skin elasticity and firmness",
        ],
        "Accessory Compatibility": [],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
        "App Connectivity": [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/supported.png?v=1768200362",
        ],
      },
    },
    boosterMiniPlus: {
      id: "boosterMiniPlus",
      name: "Mini Booster Pro Plus",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_mini_plus_pk.png?v=1779327659",
            width: "100px",
          },
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_mini_plus_bg.png?v=1779327658",
            width: "100px",
          },
        ],
        colors: ["#FFCDCD", "#F8F5E6"],
        link: "/products/mini-booster-pro-plus",
      },
      specs: {
        Mode: [
          { main: "Red LED Mode (Brightening)", sub: "*When used with brightening products" },
          { main: "Blue LED Mode (Breakout)", sub: "*When used with breakout treatment products" },
          { main: "Purple LED Mode (Radiance)" },
        ],
        Weight: ["75g"],
        "How it works": ["Electroporation"],
        Benefits: [
            { main: "Absorbs active ingredients" },
            { main: "Alleviates breakouts", sub: "*Skin concerns such as sensitivity, irritation, dryness, and roughness" },
            { main: "Brightening", sub: "*When used with brightening products" },
            { main: "Glow" },
        ],
        "Accessory Compatibility": ["supported"],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
        "App Connectivity": [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/supported.png?v=1768200362",
        ],
      },
    },
    boosterMini: {
      id: "boosterMini",
      name: "Mini Booster Pro",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_mini_pk.png?v=1768199524",
            width: "100px",
          },
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_mini_wh.png?v=1768199524",
            width: "100px",
          },
        ],
        colors: ["#FFCDCD", "#EFEFEF"],
        link: "/products/mini-booster-pro",
      },
      specs: {
        Mode: [
          { main: "Red LED Mode (Brightening)", sub: "*When used with brightening products" },
          { main: "Blue LED Mode (Breakout)", sub: "*When used with breakout treatment products" },
        ],
        Weight: ["75g"],
        "How it works": ["Electroporation "],
        Benefits: [
            { main: "Absorbs active ingredients" },
            { main: "Alleviates breakouts", sub: "*Skin concerns such as sensitivity, irritation, dryness, and roughness" },
            { main: "Brightening", sub: "*When used with brightening products" },
        ],
        "Accessory Compatibility": [],
        Bluetooth: [],
        "App Connectivity": [],
      },
    },
    boosterVroller: {
      id: "boosterVroller",
      name: "Booster V Roller",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_roller_pk02.png?v=1779327658",
            width: "130px",
          },
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_roller_be02.png?v=1779327659",
            width: "130px",
          },
        ],
        colors: ["#FFCDCD", "#F8F5E6"],
        link: "/products/mini-booster-pro-plus",
      },
      specs: {
        Mode: ["Red Mode <br class='only_mo'>(Firming & Contour Care)", "Blue Mode <br class='only_mo'>(De-puffing)", "Purple Mode <br class='only_mo'>(Body)"],
        Weight: ["145g"],
        "How it works": ["Medium-frequency (EMS)"],
        Benefits: ["Performs meridian massage", "Adds facial contour", "De-puffing", "Inner firmness"],
        "Accessory Compatibility": [],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
        "App Connectivity": [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/supported.png?v=1768200362",
        ],
      },
    },
    facialCleansingDeviceHead: {
      id: "facialCleansingDeviceHead",
      name: "Facial Cleansing Device Head",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_cleanser_pk.png?v=1779327658",
            width: "100px",
          },
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_cleanser_bg.png?v=1779327658",
            width: "100px",
          },
        ],
        colors: ["#FFCDCD", "#F8F5E6"],
        link: "/products/mini-booster-pro-plus",
      },
      specs: {
        Mode: ["Daily Mode", "Deep Mode", "Mild Mode"],
        Weight: ["140g"],
        "How it works": ["3D Vibration", "Booster Sonic", "Medium-frequency (EMS)"],
        Benefits: ["Deep cleansing", "Takes care of pores"],
        "Accessory Compatibility": [],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
        "App Connectivity": [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/supported.png?v=1768200362",
        ],
      },
    },
    ultratune: {
      id: "ultratune",
      name: "Ultra Tune 40.68",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_tune.png?v=1768198626",
            width: "100px",
          },
        ],
        colors: ["#EFEFEF"],
        link: "/products/age-r-ultra-tune-40-68",
      },
      specs: {
        Mode: [],
        Weight: ["320g"],
        "How it works": ["RF", "Microcurrent"],
        Benefits: [
          "Cares for skin elasticity and firmness",
          "Helps with volumizing the forehead, smile lines, and under-eye area",
          "Care for overall facial contours",
        ],
        "Accessory Compatibility": [],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
        "App Connectivity": [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/supported.png?v=1768200362",
        ],
      },
    },
  };

  // 브이롤러 이미지 사이즈
  function resizeRollerImages() {
    if ($(window).width() <= 768) {
      $('img[src*="roller"]').each(function() {
          this.style.setProperty('width', '65px', 'important');
      });
    } else {
      $('img[src*="roller"]').each(function() {
          this.style.setProperty('width', '130px', 'important');
      });
    }
  }

  function applyResponsiveCompareUI() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    const thirdSelect = $(".product_select").eq(2);
    const thirdLine = $(".compare_line").eq(2);

    if (isMobile) {
      thirdLine.hide();
      thirdSelect.prop("disabled", true).hide();
    } else {
      thirdLine.show();
      thirdSelect.prop("disabled", false).show();
    }
  }

  function saveState() {
    const stateToSave = [];
    $(".product_select").each(function (index) {
      const $sel = $(this);
      if ($sel.is(":disabled") || !$sel.is(":visible")) return;

      const productId = $sel.val();
      const activeIndex = $(".compare_line").eq(index).data("activeIndex") || 0;
      stateToSave.push({ id: productId, activeIndex: activeIndex });
    });

    sessionStorage.setItem("productCompareState", JSON.stringify(stateToSave));
  }

  function updateAllDisplays() {
    $(".compare_line").each(function (index) {
      const $sel = $(".product_select").eq(index);

      if ($sel.is(":disabled") || !$sel.is(":visible")) {
        $(".product_info").eq(index).html("");
        return;
      }

      const productId = $sel.val();
      if (!productData[productId]) return;

      const product = productData[productId];
      updateProductInfo(product, index);
    });
    updateAllSpecs();
    
    // 브이롤러 이미지 사이즈
    resizeRollerImages();
  }

  function updateProductInfo(product, index) {
    const productInfoContainer = $(".product_info").eq(index);
    const productColumn = $(".compare_line").eq(index);
    const routeRoot = `${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/"}/`.replace(/\/+$/, "/");

    const activeIndex = productColumn.data("activeIndex") || 0;
    const productLink = product.info.link && product.info.link.charAt(0) === "/"
      ? routeRoot + product.info.link.replace(/^\//, "")
      : product.info.link;

    const imagesHtml = product.info.images
      .map((imageObject, i) => {
        const widthStyle = imageObject.width ? `style="width:${imageObject.width};"` : "";
        const activeClass = i === activeIndex ? "on" : "";
        return `<img src="${imageObject.src}" class="${activeClass}" ${widthStyle} />`;
      })
      .join("");

    const colorsHtml = product.info.colors
      .map((color, i) => {
        const activeClass = i === activeIndex ? "on" : "";
        return `<i style="background-color:${color};" class="${activeClass}"></i>`;
      })
      .join("");

    const infoHtml = `
      <div class="thumb_image">${imagesHtml}</div>
      <div class="thumb_type">${colorsHtml}</div>
      ${productLink ? `<a href="${productLink}" class="more show">Learn more</a>` : ""}
    `;
    productInfoContainer.html(infoHtml);
  }

  function updateAllSpecs() {
    const specList = $(".spec_list .spec");
    specList.html("");

    const selectedProductIds = $(".product_select")
      .filter(":visible:not(:disabled)")
      .map(function () {
        return $(this).val();
      })
      .get();

    specList.each(function () {
      const specGroup = $(this);
      const specTitle = specGroup.prev(".spec_sub_title").text();
      let maxSpecCount = 0;

      $.each(selectedProductIds, function (_, id) {
        const product = productData[id];
        if (product) {
          const specLength = product.specs[specTitle] ? product.specs[specTitle].length : 0;
          if (specLength > maxSpecCount) maxSpecCount = specLength;
        }
      });

      if (maxSpecCount === 0) maxSpecCount = 1;

      $.each(selectedProductIds, function (_, id) {
        const product = productData[id];
        const specValues = product && product.specs[specTitle] ? product.specs[specTitle] : [];
        let specItemsHtml = "";

        for (let i = 0; i < maxSpecCount; i++) {
          const defaultValue = i === 0 ? "-" : "";
          const value = specValues[i] || defaultValue;

          if (typeof value === "string" && value.includes(".png")) {
            specItemsHtml += `<img src="${value}" alt="${specTitle}">`;
          } else if (typeof value === "object" && value !== null && value.main) {
            const subText = value.sub ? `<em class="spec_sub_text">${value.sub}</em>` : "";
            specItemsHtml += `<span>${value.main} ${subText}</span>`;
          } else {
            specItemsHtml += `<span>${value}</span>`;
          }
        }

        specGroup.append(`<div class="spec_cont">${specItemsHtml}</div>`);
      });
    });
  }

  function ensureUniqueVisibleSelects() {
    const $sels = $(".product_select").filter(":visible:not(:disabled)");
    const used = new Set();

    $sels.each(function () {
      const $sel = $(this);
      let val = $sel.val();

      if (used.has(val)) {
        // 중복이면 아직 안쓴 옵션으로 교체
        $sel.find("option").each(function () {
          const candidate = this.value;
          if (!used.has(candidate)) {
            $sel.val(candidate);
            val = candidate; 
            return false; // break
          }
        });
      }

      used.add(val);
    });
  }

  // 초기화
  function initialize() {
    const savedStateJSON = sessionStorage.getItem("productCompareState");
    let savedState = null;

    if (savedStateJSON) {
      try {
        savedState = JSON.parse(savedStateJSON);
      } catch (e) {
        console.error("저장된 상태 파싱 실패:", e);
        sessionStorage.removeItem("productCompareState");
      }
    }

    const selects = $(".product_select");
    let optionsHtml = "";

    $.each(productData, function (id, product) {
      optionsHtml += `<option value="${id}">${product.name}</option>`;
    });
    selects.html(optionsHtml);

    applyResponsiveCompareUI();

    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (savedState && Array.isArray(savedState)) {
      if (savedState[0]) {
        selects.eq(0).val(savedState[0].id);
        $(".compare_line").eq(0).data("activeIndex", savedState[0].activeIndex || 0);
      }
      if (savedState[1]) {
        selects.eq(1).val(savedState[1].id);
        $(".compare_line").eq(1).data("activeIndex", savedState[1].activeIndex || 0);
      }
      if (!isMobile && savedState[2]) {
        selects.eq(2).val(savedState[2].id);
        $(".compare_line").eq(2).data("activeIndex", savedState[2].activeIndex || 0);
      }
    } else {
      if (isMobile) {
        selects.eq(0).val("boosterProX2");
        selects.eq(1).val("boosterPro");
      } else {
        selects.eq(0).val("boosterProX2");
        selects.eq(1).val("boosterPro");
        selects.eq(2).val("boosterMiniPlus");
      }
    }
    ensureUniqueVisibleSelects();
    
    selects.each(function () {
      $(this).data("prevValue", $(this).val());
    });

    selects.on("change", function () {
      const currentSelect = $(this);

      if (currentSelect.is(":disabled") || !currentSelect.is(":visible")) return;

      const currentValue = currentSelect.val();
      const selectIndex = selects.index(currentSelect);

      let isDuplicate = false;

      selects
        .not(currentSelect)
        .filter(":visible:not(:disabled)")
        .each(function () {
          if ($(this).val() === currentValue) isDuplicate = true;
        });

      if (isDuplicate) {
        alert("This item is already selected.");
        const prev = currentSelect.data("prevValue");
        const hasPrev = prev && currentSelect.find(`option[value="${prev}"]`).length > 0;

        if (hasPrev) {
          currentSelect.val(prev);
        } else {
          currentSelect.prop("selectedIndex", 0);
          currentSelect.data("prevValue", currentSelect.val());
        }
        return;
      }

      $(".compare_line").eq(selectIndex).data("activeIndex", 0);
      currentSelect.data("prevValue", currentValue);

      updateAllDisplays();
      saveState();
    });

    $(".compare").delegate(".thumb_type i", "click", function () {
      const target = $(this);
      const productColumn = target.closest(".compare_line");
      const colIndex = $(".compare_line").index(productColumn);

      const relatedSelect = $(".product_select").eq(colIndex);
      if (relatedSelect.is(":disabled") || !relatedSelect.is(":visible")) return;

      const clickedIndex = target.index();
      productColumn.data("activeIndex", clickedIndex);

      target.addClass("on").siblings().removeClass("on");
      const productInfo = target.closest(".product_info");
      productInfo.find(".thumb_image img").removeClass("on").eq(clickedIndex).addClass("on");

      resizeRollerImages();
      saveState();
    });

    updateAllDisplays();
  }

  initialize();

  $(window).on("resize", function () {
    applyResponsiveCompareUI();
    updateAllDisplays(); 
  });

  // scroll
  $(window).scroll(function () {
    const winScroll = $(this).scrollTop(),
      selectTop = $(".prd_compare_wrap .select_container").offset().top,
      selectWrap = $(".prd_compare_wrap .select_container .select_wrap"),
      headerHeight = $(".header-wrapper").innerHeight();

    if (winScroll >= selectTop - headerHeight) {
      selectWrap.addClass("fixed");
    } else {
      selectWrap.removeClass("fixed");
    }
  });
});
